/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Tier_TitleInputs */

const en_fw_bm_tier_title = /** @type {(inputs: Fw_Bm_Tier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By tier and agent`)
};

const id_fw_bm_tier_title = /** @type {(inputs: Fw_Bm_Tier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per tingkat dan agen`)
};

/**
* | output |
* | --- |
* | "By tier and agent" |
*
* @param {Fw_Bm_Tier_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_tier_title = /** @type {((inputs?: Fw_Bm_Tier_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Tier_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_tier_title(inputs)
	return en_fw_bm_tier_title(inputs)
});